import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Divider,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";

export default function BookkeeperMultiSelectPopover({
  value,
  onValueChange,
  bookkeepers,
  loadingBookkeepers,
  onClose,
  onSearch,
  onClear,
}) {
  const selectedValues = value ? value.split(",").filter((v) => v) : [];

  return (
    <Box sx={{ minWidth: 260, width: 320, p: 0, m: 0 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1.5,
          pt: 0.5,
          pb: 1,
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: "bold", color: "#111827" }}>
          Filter By Bookkeeper
        </Typography>
        <IconButton size="small" onClick={onClose} sx={{ p: 0.5, color: "#6B7280" }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Divider sx={{ width: "100%", m: 0, p: 0 }} />

      <Box sx={{ p: 1.5 }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: "#627CFB",
            mb: 1,
            fontSize: "0.875rem",
          }}
        >
          Bookkeeper
        </Typography>

        <FormControl fullWidth variant="standard" size="small" sx={{ mb: 2 }}>
          <InputLabel sx={{ color: "#9CA3AF", fontSize: "0.875rem" }}>
            Select Bookkeeper(s)
          </InputLabel>
          <Select
            multiple
            value={selectedValues}
            onChange={(e) => {
              const raw = e.target.value;
              const next = typeof raw === "string" ? raw : raw.join(",");
              onValueChange(next);
            }}
            label="Select Bookkeeper(s)"
            IconComponent={ExpandMoreIcon}
            disabled={loadingBookkeepers}
            renderValue={(selected) => (
              <Typography
                variant="body2"
                sx={{
                  fontSize: "0.875rem",
                  color: selected.length ? "#000000" : "#9CA3AF",
                }}
              >
                {selected.length === 0
                  ? "Select Bookkeeper(s)"
                  : `${selected.length} selected`}
              </Typography>
            )}
            sx={{
              fontSize: "0.875rem",
              "&:before": {
                borderBottom: "2px solid #627CFB",
              },
              "&:after": {
                borderBottom: "2px solid #627CFB",
              },
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid #627CFB",
              },
              "& .MuiSelect-select": {
                paddingBottom: "8px",
                fontSize: "0.875rem",
              },
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 400,
                  zIndex: 99999,
                },
              },
              style: {
                zIndex: 99999,
              },
            }}
          >
            {loadingBookkeepers ? (
              <MenuItem disabled>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                  Loading...
                </Typography>
              </MenuItem>
            ) : (
              bookkeepers.map((bookkeeper) => (
                <MenuItem
                  key={bookkeeper.id}
                  value={bookkeeper.name}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    py: 1,
                    px: 1.5,
                    "&:hover": {
                      backgroundColor: "#F3F4F6",
                    },
                  }}
                >
                  <Checkbox
                    checked={selectedValues.includes(bookkeeper.name)}
                    disableRipple
                    sx={{
                      p: 0,
                      mr: 1.5,
                      "&.Mui-checked": {
                        color: "#627CFB",
                      },
                    }}
                  />
                  <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                    {bookkeeper.name}
                  </Typography>
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>

        <Button
          onClick={onSearch}
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#627CFB",
            color: "white",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "0.875rem",
            mb: 1,
            "&:hover": {
              backgroundColor: "#536DEC",
            },
          }}
        >
          Search
        </Button>

        <Button
          onClick={onClear}
          size="small"
          fullWidth
          sx={{
            color: "#627CFB",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "0.875rem",
            "&:hover": {
              backgroundColor: "rgba(98, 124, 251, 0.04)",
            },
          }}
        >
          Clear Search
        </Button>
      </Box>
    </Box>
  );
}
